import _ from 'lodash'
import {IDataSource} from '.'
import {listToMap, parseItem} from '@/utils/media'

export function askSource<T extends {catalog: string; query: string}>(args: T): IDataSource<T> {
  const {catalog, query} = args

  const _query = _.trim(query)

  return {
    sourceID: 'ask',
    key: _query,
    args,
    fetch: async () => {
      const params = new URLSearchParams({
        catalog,
        q: _query,
      })
      const response = await fetch(`/api/gfp-result/text/similar?${params.toString()}`)
      if (!response.ok) throw new Error('failed to fetch ask response')
      const data = await response.json()
      return listToMap(_.map(data.similar || [], parseItem))
    },
  }
}
